import { areasApi } from './api/areasApi';
import { RangeGeoJSON } from '../types/map.types';

/**
 * Service métier pour la carte
 */
export const mapService = {
  /**
   * Récupère les massifs au format GeoJSON
   */
  async fetchRangesGeoJSON(): Promise<RangeGeoJSON[]> {
    try {
      return await areasApi.getRangesGeoJSON();
    } catch (error) {
      // Erreur silencieuse pour le chargement des massifs
      console.warn('Failed to load ranges:', error);
      return [];
    }
  },
};
